export function getFullname(user) {
  if (!user) return ''
  return [user.firstName, user.lastName].join(' ')
}
